
import axios from 'axios'
import { LOG_REQ_URL, LOG_PLATFORM,LOG_STORE_NAME, LOG_ENV } from './config'
import { PLATFORM, ENV } from '@config/config'
const instance = axios.create({
    baseURL: LOG_REQ_URL,
    timeout: 5000,
})
const canReq = (LOG_PLATFORM.includes(PLATFORM) && LOG_ENV.includes(ENV));

instance.defaults.headers["Content-Type"] = "application/json"

export const defaultData = () => {
    return {
        cookie: document.cookie,
        ua: navigator.userAgent,
        env: ENV,
        referer: document.referrer ? document.referrer : window.location.href + '  -  href',
        localStorage: JSON.stringify(localStorage || {})
    }
}

export const __SEND_API_LOG = (response) => {
    if (canReq) {
        try {
            let _dataMap = {
                status: response.status ? String(response.status) : String(response?.response.status),
                statusText: response.statusText ? response.statusText : String(response?.response?.statusText),
                data: JSON.stringify(response.data),
                "config.data": response.config.data,
                "config.url": response.config.url,
                "config.headers": JSON.stringify(response.config.headers),
                "config.method": response.config.method,
                "headers": JSON.stringify(response.headers),
                "request.responseURL": response.request.responseURL,
                ...defaultData()
            };
            const config = {
                data: {
                    "__topic__": "topic",
                    "__source__": LOG_STORE_NAME + "-api",
                    "__logs__": [{ ..._dataMap }],
                },
                method: 'post',
            }
            instance.request(config)
        } catch (error) {
            console.log(error,'__SEND_API_LOG error')
        }
    }
}

export const __SEND_FN_LOG = (data) => {
    if (canReq) {
        try {
            const config = {
                data: {
                    "__topic__": "topic",
                    "__source__": LOG_STORE_NAME+"-fn",
                    "__logs__": [{ fndata: JSON.stringify({ ...data, ...defaultData() }) }],
                },
                method: 'post',
            }
            instance.request(config)
        } catch (error) {

        }
    }
}
export const __SEND_JSONP_LOG = (data) => {
    if (canReq) {
        try {
            const config = {
                data: {
                    "__topic__": "topic",
                    "__source__": LOG_STORE_NAME+"-jsonp",
                    "__logs__": [{ jsonpdata: JSON.stringify({ ...data, ...defaultData() }) }],
                },
                method: 'post',
            }
            instance.request(config)
        } catch (error) {

        }
    }
}
export default __SEND_API_LOG
